import { convertTextOptionsToJson } from 'utilities/customFieldUtils';
import { isMultiSelectField } from '../SingleEntryOptionsList/logic';

export const convertRawOptionsToJson = convertTextOptionsToJson;

export const selectDefaultsMatchingOptions = (
  selectFieldType,
  optionsList,
  defaults
) => {
  return isMultiSelectField(selectFieldType)
    ? optionsList.reduce((defaultValues, { value }) => {
        if (defaults?.includes(value)) {
          defaultValues.push(value);
        }
        return defaultValues;
      }, [])
    : optionsList.find(({ value }) => defaults === value)?.value;
};
